import { TFunction } from 'next-i18next'
import { User } from 'src/core/models'

const panels = {
  DETAILS: 'DETAILS',
  COMPANY: 'COMPANY',
  ACCOUNT: 'ACCOUNT'
}

export const getSettingsSections = (t: TFunction, user: User) => [

  /* Panel Details */
  {
    key: panels.DETAILS,
    headerProps: {
      title: t('settings.personalDetails'),
      subtitle: t('settings.personalDetailsLabel')
    },
    panels: [
      { // Personal Details
        isVisible: true,
        props: {
          title: t('settings.personalDetails'),
          subtitle: t('settings.personalDetailsLabel2'),
          link: '/settings/personal-details'
        }
      },
      { // Company Details
        isVisible: user?.is_business,
        props: {
          title: t('settings.companyDetails'),
          subtitle: t('settings.companyDetailsLabel'),
          link: '/settings/company-details'
        }
      },
      { // Company Files
        isVisible: user?.is_business,
        props: {
          title: t('settings.companyFiles'),
          subtitle: t('settings.companyFilesLabel'),
          link: '/settings/company-files'
        }
      }
    ]
  },

  /* Preferences */
  {
    key: panels.COMPANY,
    headerProps: {
      title: t('settings.settings'),
      subtitle: t('settings.settingslabel')
    },
    panels: [
      { // User Preferences
        isVisible: true,
        props: {
          title: t('settings.userPreferences'),
          subtitle: t('settings.userPreferencesLabel'),
          link: '/settings/user-preferences'
        }
      },
    ]
  },

  /* User Configuration */
  {
    key: panels.ACCOUNT,
    headerProps: {
      title: t('settings.configuration'),
      subtitle: t('settings.configurationLabel')
    },
    panels: [
      { // Subscription details
        isVisible: user?.is_widget,
        props: {
          title: t('Subscription.Details'),
          subtitle: t('Subscription.Plan'),
          link: '/settings/subscription-details'
        }
      },
      { // Permissions
        isVisible: true,
        props: {
          title: t('Permisions.Main'),
          subtitle: t('Permisions.Subtitle'),
          link: '/settings/manage-permissions'
        }
      },
      { // Change Password
        isVisible: true,
        props: {
          title: t('settings.ChangePassword'),
          subtitle: t('settings.deleteAccount'),
          link: '/settings/change-password'
        }
      },
    ]
  }
]
